import styled, { css } from "styled-components";

const wrapperModifiers = {
  success: (theme) => css`
    background-color: ${theme.lightTheme.colors.success};
    svg {
      color: ${theme.lightTheme.colors.darkBlack};
    }
  `,
  error: (theme) => css`
    background-color: ${theme.lightTheme.colors.danger};
    svg {
      color: ${theme.lightTheme.colors.darkBlack};
    }
  `,
  warning: (theme) => css`
    background-color: ${theme.lightTheme.colors.warning};
    svg {
      color: ${theme.lightTheme.colors.darkBlack};
    }
  `,
  generic: (theme) => css`
    background-color: ${theme.lightTheme.colors.gray};
    svg {
      color: ${theme.lightTheme.colors.darkBlack};
    }
  `,
};

export const Wrapper = styled.div`
  ${({ theme, variant }) => css`
    width: 100%;
    max-width: 600px;
    padding: ${theme.spacings.medium};
    border-radius: 5px;
    margin: 0.5rem auto;
    display: flex;
    align-items: center;

    span {
      color: ${theme.lightTheme.colors.text};
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 130%;
      display: inline;
      align-items: center;
    }
    svg {
      width: 1.5rem;
      height: 1.5rem;
      min-width: 25px;
      margin-right: 0.5rem;
    }
    a {
      color: ${theme.lightTheme.colors.text};
      text-decoration: underline;
    }

    ${variant && wrapperModifiers[variant](theme)}
  `}
`;
